import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton, SelectFilter } from '@/components';
import { useSearchParams } from '@/hooks';
import { Flex, CryptoIcon, Heading, useTableProps } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';
import { useMemo } from 'react';
import { NSC_URN_OPERATIONS } from '@/constants';

export default function ILKActivityPage() {
  const { ilk } = useParams();
  const [daysAgo] = useSearchParams('days_ago', '1');

  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All events', value: '' }];
    options.push(
      ...Object.entries(NSC_URN_OPERATIONS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.eventType
      }))
    );
    return options;
  }, [filters]);

  const [data, error] = useApi({
    url: `/groups/core/ilks/${ilk}/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={<CryptoIcon name={data.collateral_symbol} size="4" />}>
            <Heading size="1">{data.ilk} Activity</Heading>
          </EntityName>
        }>
        <HistoricTabs ilk={ilk} />
        <Flex justifyContent="space-between" alignItems="center">
          <Heading size="3">Events</Heading>
          <SelectFilter
            key="event-filter"
            filterField="eventType"
            options={selectFilterOptions}
            pagination={pagination}
            {...filters}
          />
        </Flex>
        <EventsTable
          collateralSymbol={data.collateral_symbol}
          collateralAddress={data.collateral_address}
          pagination={pagination}
          sorting={sorting}
          filters={filters}
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
